export const ACCOUNT_TYPES = [1, 4, 12]
export const ACCOUNT_GROUP_BY = ["H", "P"]

export const RIGHT_PROCESS = 111101
export const RIGHT_FILTER = 111102
export const RIGHT_PREVIEW = 111103